module.exports = __webpack_public_path__ + "static/media/ramen_seafood.055284cc.jpg";